import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["overflowY"];
import { FlexItem as InstUIFlexItem } from '@instructure/ui-flex';
import React, { forwardRef } from 'react';
export var FlexItem = forwardRef(function (_ref, ref) {
  var _ref$overflowY = _ref.overflowY,
    overflowY = _ref$overflowY === void 0 ? 'visible' : _ref$overflowY,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(InstUIFlexItem, Object.assign({}, props, {
    ref: ref,
    overflowY: overflowY
  }));
});
FlexItem.displayName = 'FlexItem';